export const SYLLABUS_CONTENT_DP = "syllabusContentDP";
export const LEARNING_STANDARD_UBD = "learningStandardUBD";
export const LEARNING_STANDARD_PYP = "benchmarks";

export const CONTEXT_FIELDS = {
  CF_MYP_CONTENT: "mypContent",
  CF_NUMBER_OF_QUESTIONS: "numberOfQuestions",
  CF_TYPE_OF_QUESTIONS: "typeOfQuestions",
  CF_AI_INSTRUCTIONS: "aiInstructions",
  CF_SYLLABUS_CONTENT_DP: SYLLABUS_CONTENT_DP,
  CF_LEARNING_STANDARD_UBD: LEARNING_STANDARD_UBD,
  CF_LEARNING_STANDARD_PYP: LEARNING_STANDARD_PYP,
};

export const WORKSHEET_AI_GEN_ACTIONS = {
  GENERATE_WORKSHEET_QUESTIONS: "generate_worksheet_questions",
  WORKSHEET_GENERATE_P1: "worksheet_generate_p1",
  WORKSHEET_GENERATE_P2: "worksheet_generate_p2",
};

export const MAX_QUESTION_GENERATION_COUNT = 10;
